import React from 'react';
import { AlertTriangleIcon, UserCheckIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { audiences } from '../../data/content';
export function Audience() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-55" data-mp="1dx760x1g3rxx">
      <div className="mx-auto max-w-4xl" data-id="element-56" data-mp="1duufvwljab9s">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-57" data-mp="1hxhgalw9t4il">Who Is This Blueprint For?</h2>
        <p className="mt-3 text-center text-lg text-navy/75" data-id="element-58" data-mp="25lqup2r5mpzp">Designed for professionals who need a practical planning structure.</p>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-59" data-mp="1wnf59420xy8u">
          {audiences.map(a => <div key={a.title} className="flex gap-4 rounded-2xl bg-white p-5" data-id="element-60" data-mp="21lqfvh058cs4">
              <UserCheckIcon className="h-7 w-7 shrink-0 text-brand" aria-hidden="true" data-id="element-61" data-mp="l800vf7hk43p" />
              <div data-id="element-62" data-mp="lacpucbnveq9">
                <h3 className="font-display text-lg font-extrabold leading-snug text-navy" data-id="element-63" data-mp="q6tauxnkdcz4">{a.title}</h3>
                <p className="mt-1 text-[15px] text-navy/75" data-id="element-64" data-mp="zlrwhg7sr0t1">{a.body}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-8 flex gap-3 rounded-2xl border border-accent/40 bg-accent-light p-5 text-sm text-navy" data-id="element-65" data-mp="uorogzrdznza">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-accent-dark" aria-hidden="true" data-id="element-66" data-mp="19lsf0zxudcw6" />
          <p data-id="element-67" data-mp="14k35xpu6j9aq">
            <strong data-id="element-68" data-mp="14nqzgozmjvpg">Important:</strong> This resource is intended for qualified professionals. It is not a diagnostic instrument, a substitute for clinical training, or a standardized motor planning assessment. All tools must be adapted to the child's needs, clinical findings, and applicable professional standards.
          </p>
        </div>

        <SectionCTA label="Yes, This Is for Me" data-id="element-69" data-mp="1nbm7rtcgwhb6" />
      </div>
    </section>;
}